import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getProjects } from 'store/actions';
import MediaFile from 'Flow2/util/MediaFile';

const initialState = {
    currentClip: null,
    tickedClips: [],
    multiSelectedClips: [],
    clips: {},
    draggedClipId: null,
    massEditClips: [],
    relatedClip: null,
    currentRelatedClips: [],
    isGrabbingMainThumb: false
};

const cutClipStart = (state, action) => {
    return updateObject(state, { cutting: true });
}

const cutClipSuccess = (state, action) => {
    return updateObject(state, { cutting: false });
}

const reducer = (state = initialState, action) => {
    let newTicked = [];
    let newMultiSelected = [];
    switch (action.type) {
        case actionTypes.CUT_CLIP_SUCCESS:
            return (cutClipSuccess(state, action));
        case actionTypes.CUT_CLIP_START:
            return (cutClipStart(state, action));
        case actionTypes.SELECT_CLIP:
            return updateObject(state, { currentClip: action.payload.clip });
        case actionTypes.UPLOAD_UPDATE_METADATA:
            let updatedCurrentClip = updateObject(state.currentClip, { mediafiles: action.payload.mediafiles })
            return updateObject(state, { currentClip: updatedCurrentClip });
        case actionTypes.TICK_CLIP:
            if (state.tickedClips.indexOf(action.payload.clipId) > -1) {
                return state;
            }
            newTicked = [...state.tickedClips.slice(0, state.tickedClips.indexOf(action.payload.clipId)), action.payload.clipId, ...state.tickedClips.slice(state.tickedClips.indexOf(action.payload.clipId))];
            return updateObject(state, { tickedClips: newTicked });
        case actionTypes.UNTICK_CLIP:
            newTicked = state.tickedClips.filter((item) => item !== action.payload.clipId)
            return updateObject(state, { tickedClips: newTicked });
        case actionTypes.RESET_TICKED_CLIPS:
            return updateObject(state, { tickedClips: [] });
        case actionTypes.CLIP_DRAG_START:
            return updateObject(state, { draggedClipId: action.payload.clipId });
        case actionTypes.CLIP_ADD_MULTISELECTED:
            if (state.multiSelectedClips.indexOf(action.payload.clipId) > -1) {
                return state;
            }
            newMultiSelected = [...state.multiSelectedClips.slice(0, state.multiSelectedClips.indexOf(action.payload.clipId)), action.payload.clipId, ...state.multiSelectedClips.slice(state.multiSelectedClips.indexOf(action.payload.clipId))];
            return updateObject(state, { multiSelectedClips: newMultiSelected });
        case actionTypes.CLIP_REMOVE_MULTISELECTED:
            newMultiSelected = state.multiSelectedClips.filter((item) => item !== action.payload.clipId)
            return updateObject(state, { multiSelectedClips: newMultiSelected });
        case actionTypes.RESET_MULTISELECTED:
            return updateObject(state, { multiSelectedClips: [] });
        case actionTypes.MASS_EDIT_SELECTED:
            return updateObject(state, { massEditClips: action.payload.clips });
        case actionTypes.RESET_MASS_EDIT_SELECTED:
            return updateObject(state, { massEditClips: [] });
        case actionTypes.SET_RELATED_CLIP:
            return updateObject(state, { relatedClip: action.payload.relatedClip, currentRelatedClips: action.payload.currentClips });
        case actionTypes.CLIP_GRAB_MAINTHUMB_START:
            return updateObject(state, { isGrabbingMainThumb: true });
        case actionTypes.CLIP_GRAB_MAINTHUMB_FAIL:
            return updateObject(state, { isGrabbingMainThumb: false });
        case actionTypes.CLIP_GRAB_MAINTHUMB_SUCCESS:
            return updateObject(state, { isGrabbingMainThumb: false });
        default:
            return state;
    }
}

export default reducer;
